import type { LoadedScene, WorldPanel } from '@viewer/world/worldTypes';

function isMobileMediaPanel(panel: WorldPanel): boolean {
  return panel.type === 'video' || panel.type === 'videoModel';
}

function isEagerMobilePanel(
  panel: WorldPanel,
  options: { retainMediaPanels?: boolean },
): boolean {
  if (isMobileMediaPanel(panel)) return options.retainMediaPanels !== false;
  if (panel.type === 'model' && panel.autoplay !== false) return false;
  return true;
}

export function optimiseWorldSceneForDevice(
  scene: LoadedScene,
  options: { mobileLayout: boolean; retainMediaPanels?: boolean },
): LoadedScene {
  if (!options.mobileLayout || !scene.panels || scene.panels.length === 0) return scene;

  return {
    ...scene,
    panels: scene.panels.filter((panel) => isEagerMobilePanel(panel, options)),
  };
}
